module.exports = __webpack_public_path__ + "4fa3b2355baf0c7c5e25ab9e53188953.MP3";